// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-view-async {
  display: flex;
  flex: 1 1 100%;
  width: 100%;
  height: 100%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ViewAsync/ViewAsync.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACJ","sourcesContent":[".dl-view-async {\n  display: flex;\n  flex: 1 1 100%;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
